module.exports = __webpack_public_path__ + "static/media/sort-arrow-down-active.6512d8ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Kendra/images/sort-arrow-down-active.svg
// module id = 3240
// module chunks = 0